import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormArray, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { debounceTime, delay, filter, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { countryService } from './country.service';
import { selectService } from 'src/app/shared/models/dropdown-demo-data';

@Component({
    selector: 'app-country',
    templateUrl: './country.component.html',
    styleUrls: ['./country.component.less'],
    standalone: false
})
export class CountryComponent {
  myForm: FormGroup;
  countryCode = this.selectService.selectList;
  filteredCountryCode = this.selectService.selectList$;
  searching = false;
  onDestroy = new Subject<void>();
  stateMode: 'view' | 'edit' = 'view';
  stateIndex: number;
  stateCol: any[] = [
    { id: 'stateCode', name: 'State Code' },
    { id: 'stateName', name: 'State Name' },
    { id: '$$edit', name: '$$edit' },
  ]
  stateColumns: any[] = this.stateCol.map(col => col.id);
  stateDataSource = this.service.stateList$;

  documentMode: 'view' | 'edit' = 'view';
  documentIndex: any;
  documentCol: any[] = [
    { id: 'documentCode', name: 'Document Code' },
    { id: 'documentName', name: "Document Name" },
    { id: 'documentType', name: "Document Type" },
    { id: 'mandatory', name: "Mandatory" },
    { id: "$$edit", name: "$$edit" }
  ];
  documentColumns: any[] = this.documentCol.map(col => col.id);
  documentDataSource = this.service.documentList$;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredCountry: Observable<string[]>;
  country: string[] = [];
  allCountry: string[] = ['Accountant', 'CS', 'Developer'];

  @ViewChild('countryInput') countryInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private service: countryService, public selectService: selectService,public fb: FormBuilder) {
    
  }
  reactiveForm() {
    this.myForm = this.fb.group({
      countryCodeCtrl: [null],
      countryCodeFilteringCtrl: [null],
      stateControls: FormArray,
      documentControls: FormArray,
      countryCtrl: [null],
    })
    this.filteredCountry = this.myForm.controls["countryCtrl"].valueChanges.pipe(startWith(''),
      map(value => this.allCountry)
    );
    this.controlState();
    this.controlDocument();
  }
  ngOnInit() {
    this.reactiveForm();
    this.selectFill();
  }
  editState(index: number) {
    this.stateIndex = index;
    this.stateMode = 'edit';
    return false;
  }
  removeState(index: number) {
    this.service.removeState(index);
    this.controlState();
  }
  updateState(index: number) {
    if (this.stateMode == 'edit') {
      this.stateMode = 'view';
      this.stateIndex = 0;
      let stateValueList = Object.keys(this.service.stateList$.value[index]);
      for (let prop in stateValueList) {
        const control = this.getControlState(index, stateValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.service.updateState(index, stateValueList[prop], control.value);
          }
          if (control.invalid) {
            this.stateMode = 'edit';
            this.stateIndex = index + 1;
            break;
          }
        }
      }
    }
  }
  newState(keyEvent, index: number) {
    if (keyEvent.key == "Tab") {
      let Status = 0;
      let stateValueList = Object.keys(this.service.stateList$.value[index]);
      for (let prop in stateValueList) {
        const control = this.getControlState(index, stateValueList[prop]);
        if (control != null) {
          if (control.invalid) {
            Status = 1;
          }
        }
      }
      if (Status == 0) {
        for (let prop in stateValueList) {
          const control = this.getControlState(index, stateValueList[prop]);
          if (control != null) {
            if (control.valid) {
              this.service.updateState(index, stateValueList[prop], control.value);
            }
          }
        }
        this.service.addState(index + 1)
        this.controlState();
      }
    }
  }
  getControlState(index: number, fieldName: string) {
    var arrayControlState = this.myForm.get('stateControls') as FormArray;
    return arrayControlState.at(index).get(fieldName) as FormControl;
  }
  getControlDocument(index: number, fieldName: string) {
    var arrayControlDocument = this.myForm.get('documentControls') as FormArray;
    return arrayControlDocument.at(index).get(fieldName) as FormControl;
  }
  controlState() {
    const togroups = this.service.stateList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position, Validators.required),
        stateCode: new FormControl(entity.stateCode, Validators.required),
        stateName: new FormControl(entity.stateName, Validators.required)
      }, { updateOn: "blur" });
    });
    this.myForm.controls.stateControls = new FormArray(togroups);
  }
  controlDocument() {
    const togroups = this.service.documentList$.value.map(entity => {
      return new FormGroup({
        position: new FormControl(entity.position, Validators.required),
        documentName: new FormControl(entity.documentName, Validators.required),
        documentType: new FormControl(entity.documentType, Validators.required),
        mandatory: new FormControl(entity.mandatory),
        documentCode: new FormControl(entity.documentCode, Validators.required),
      }, { updateOn: "blur" });
    });
    this.myForm.controls.documentControls = new FormArray(togroups);
  }
  editDocument(index: number) {
    this.documentIndex = index;
    this.documentMode = 'edit';
    return false;
  }
  removeDocument(index: number) {
    this.service.removeDocument(index);
    this.controlDocument();
  }
  updateDocument(index: number) {
    if (this.documentMode == 'edit') {
      this.documentMode = 'view';
      this.documentIndex = 0;
      let documentValueList = Object.keys(this.service.documentList$.value[index]);
      for (let prop in documentValueList) {
        const control = this.getControlDocument(index, documentValueList[prop]);
        if (control != null) {
          if (control.valid) {
            this.service.updateDocument(index, documentValueList[prop], control.value);
          }
          if (control.invalid) {
            this.documentMode = 'edit';
            this.documentIndex = index + 1;
            break;
          }
        }
      }
    }
  }


  removeCountry(value: string): void {
    const index = this.country.indexOf(value);
    if (index >= 0) {
      this.country.splice(index, 1);
    }
  }

  selectedCountry(event: MatAutocompleteSelectedEvent): void {
    this.country.push(event.option.viewValue);
    this.countryInput.nativeElement.value = '';
    this.myForm.controls.countryCtrl.setValue(null);
  }
  selectFill() {
    this.myForm.controls.countryCodeFilteringCtrl.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.countryCode) {
            return [];
          }
          return this.countryCode.filter(e => e.name.toLowerCase().indexOf(search) > -1);
        }),
        delay(500)
      )
      .subscribe(filteredClient => {
        this.searching = false;
        this.filteredCountryCode.next(filteredClient);
      },
        error => { this.searching = false; });
  }
  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
